import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';

const useStyles = makeStyles()(() => ({
  root: {
    overflow: 'hidden',
    display: 'flex',
    height: '100%',
    position: 'relative',
  },
}));

/**
 * @description The container for the main content of a page.
 */
export default function Body({ children }: { children: React.ReactNode }) {
  const { classes } = useStyles();
  return <Box className={classes.root}>{children}</Box>;
}
